import { IDotThi } from "../../../model/response/to-chuc-thi/IDotThi";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDotThiActions = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IDotThi[],
    LOAD_ERROR: "",
}

export const eDotThiActionIds = generateActionTypeIds(eDotThiActions, "DOT_THI");
export type IDotThiActionTypes = IGenericActionType<typeof eDotThiActions, "DOT_THI">;